import * as moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, Table } from "reactstrap";
import DOMPurify from "dompurify";

import SimpleBar from "simplebar-react";
import LOAHeader from "./LOAHeader";
import FileIcon from "Components/Common/FileIcon";
import Permission from "Components/Common/Permission";

const FundingStatus = ({ fundingStatus }: { fundingStatus: string }) => {
  //   In-progress
  // Pending
  // Complete
  // Denied
  if (!fundingStatus) {
    return null;
  }
  if (fundingStatus === "Pending") {
    return (
      <span className="badge bg-warning-subtle text-warning fs-12">
        {fundingStatus}
      </span>
    );
  }
  if (fundingStatus === "In Progress") {
    return (
      <span className="badge bg-info-subtle text-info fs-12">
        {fundingStatus}
      </span>
    );
  }
  if (fundingStatus === "Denied") {
    return (
      <span className="badge bg-danger-subtle text-danger fs-12">
        {fundingStatus}
      </span>
    );
  }
  if (fundingStatus === "Complete") {
    return (
      <span className="badge bg-success-subtle text-success fs-12">
        {fundingStatus}
      </span>
    );
  }

  return (
    <span className="badge bg-secondary-subtle text-secondary fs-12">
      {fundingStatus}
    </span>
  );
};

const LOAContent = ({
  request,
  fetchData,
}: {
  request: any;

  fetchData: () => {};
}) => {
  return (
    <Row className="justify-content-center">
      <Col xxl={9}>
        <Card>
          {/* @ts-ignore */}
          {/* <div style={watermarkStyle}>This is not a valid request</div> */}
          <Row>
            <Col lg={12}>
              <LOAHeader request={request} fetchData={fetchData} />
            </Col>
            <Col lg={12}>
              <CardBody className="p-4">
                <Row className="g-3">
                  <Col lg={3} xs={6}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                      Date of Request
                    </p>
                    <h5 className="fs-14 mb-0">
                      <span id="invoice-no">
                        {(request?.dateOfRequest &&
                          moment(request?.dateOfRequest).format("DD MMM Y")) ||
                          "Not Provided"}
                      </span>
                    </h5>
                  </Col>
                  <Col lg={3} xs={6}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                      LOA Period/Duration
                    </p>
                    <h5 className="fs-14 mb-0">
                      {((request?.startDate || request?.endDate) && (
                        <>
                          <span id="invoice-date">
                            {request?.startDate &&
                              moment(new Date(request?.startDate)).format(
                                "DD MMM Y"
                              )}
                          </span>{" "}
                          -{" "}
                          <span id="invoice-date">
                            {request?.endDate &&
                              moment(new Date(request?.endDate)).format(
                                "DD MMM Y"
                              )}
                          </span>
                        </>
                      )) ||
                        "Not Provided"}
                    </h5>
                  </Col>

                  <Col lg={3} xs={6}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                      Reporting Entity
                    </p>

                    <h5 className="fs-14 mb-0">
                      <span id="invoice-no">
                        {request?.entity || "Not Provided"}
                      </span>
                    </h5>
                  </Col>
                  <Col lg={3} xs={6}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                      Reporting Agency
                    </p>
                    <Link to={`#`} className="">
                      <h5 className="fs-14 mb-0 ">
                        {request?.agency?.name || "Not Provided"}
                      </h5>
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Col>
            <Col lg={12}>
              <CardBody className="p-4 border-top border-top-dashed">
                <Row className="g-3">
                  <Col sm={6}>
                    <h6 className="text-muted text-uppercase fw-semibold mb-3">
                      LOA Details
                    </h6>

                    <div
                      className="table-responsive border border-dashed rounded p-2  mb-3 h-100"
                      // style={{ minHeight: "200px" }}
                    >
                      <table className="table table-md table-borderless table-striped mb-0">
                        <tbody>
                          {request?.requestTitle && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Request Title:
                              </td>
                              <td>{request?.requestTitle || "Not Provided"}</td>
                            </tr>
                          )}
                          {request?.nameOfRequester && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Name of Requester:
                              </td>
                              <td>
                                {request?.nameOfRequester || "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.objectiveOfRequest && (
                            <tr>
                              <td className="fw-medium text-muted">
                                Objective of Request:
                              </td>
                              <td>
                                {request?.objectiveOfRequest || "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.startDate && (
                            <tr>
                              <td className="fw-medium text-muted">
                                Start Date:
                              </td>
                              <td>
                                {request?.startDate &&
                                  moment(new Date(request?.startDate)).format(
                                    "DD MMM Y"
                                  )}
                              </td>
                            </tr>
                          )}
                          {request?.endDate && (
                            <tr>
                              <td className="fw-medium text-muted">
                                End Date:
                              </td>
                              <td>
                                {request?.endDate &&
                                  moment(new Date(request?.endDate)).format(
                                    "DD MMM Y"
                                  )}
                              </td>
                            </tr>
                          )}
                          {request?.fundingStatus && (
                            <tr>
                              <td className="fw-medium text-muted">
                                Funding Status:
                              </td>
                              <td>
                                {(request?.fundingStatus && (
                                  <FundingStatus
                                    fundingStatus={request?.fundingStatus}
                                  />
                                )) ||
                                  "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.formOfGovernmentRequest && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Form of Government Request:
                              </td>
                              <td>
                                {request?.formOfGovernmentRequest ||
                                  "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.contactPerson && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Contact Person:
                              </td>
                              <td>
                                {request?.contactPerson || "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.positionTitle && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Position Title:
                              </td>
                              <td>
                                {request?.positionTitle || "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.noOfPositionsRequested && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Number of Positions <br /> Requested:
                              </td>
                              <td>
                                {request?.noOfPositionsRequested ||
                                  "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.positionType?.name && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Position Type:
                              </td>
                              <td>
                                {request?.positionType?.name || "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.requestedSalary && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Requested Salary:
                              </td>
                              <td>
                                {(request?.requestedSalary &&
                                  "$" +
                                    request?.requestedSalary?.toLocaleString()) ||
                                  "Not Provided"}
                              </td>
                            </tr>
                          )}
                          {request?.periodInMonths && (
                            <tr>
                              <td
                                className="fw-medium text-muted"
                                style={{ whiteSpace: "nowrap", width: "25%" }}
                              >
                                Period in Months:
                              </td>
                              <td>
                                {request?.periodInMonths || "Not Provided"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <h6 className="text-muted text-uppercase fw-semibold mb-3">
                      Additional Details
                    </h6>

                    <div className="table-responsive border border-dashed rounded p-2  mb-3 h-100">
                      <table className="table table-md table-borderless table-striped mb-0">
                        <tbody>
                          <tr>
                            <td
                              className="fw-medium text-muted"
                              style={{ whiteSpace: "nowrap", width: "30%" }}
                            >
                              {" "}
                              Expected Outputs:
                            </td>
                            <td>
                              {request?.expectedOutputs || "Not Provided"}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-medium text-muted">
                              Additional Details:
                            </td>
                            <td>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    request?.additionalDetails || "Not Provided"
                                  ),
                                }}
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-medium text-muted">
                              Request Description:
                            </td>
                            <td>
                              {request?.requestDescription || "Not Provided"}{" "}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-medium text-muted">
                              Review of Request:
                            </td>
                            <td>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    request?.reviewOfRequest || "Not Provided"
                                  ),
                                }}
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Col>
            <Col lg={12}>
              <CardBody className="p-4">
                <div className="pt-3  mt-2">
                  <h6 className="mb-3 fw-semibold text-uppercase">
                    Documents & Resources
                  </h6>

                  <Row className="g-3">
                    {(request?.documentAttachments &&
                      request?.documentAttachments?.map(
                        (doc: any, i: number) => {
                          const url = `${process.env.REACT_APP_FILES_URL}${doc?.url}`;
                          const target = "_blank";
                          return (
                            <Col xxl={6} lg={6}>
                              <div
                                className="border rounded border-dashed p-2"
                                key={i}
                              >
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm">
                                      <div className="avatar-title bg-light text-secondary rounded fs-24">
                                        <FileIcon fileName={doc?.name} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="fs-13 mb-1">
                                      <Permission
                                        alternative={
                                          <Link
                                            to="#"
                                            className="text-body text-truncate d-block"
                                          >
                                            {doc?.name}
                                          </Link>
                                        }
                                        resource={"government-request"}
                                        action={"download"}
                                        controller="loa"
                                      >
                                        <Link
                                          to={`${url}`}
                                          className="text-body text-truncate d-block"
                                          target={target}
                                        >
                                          {doc?.name}
                                        </Link>
                                      </Permission>
                                    </h5>
                                    <div>{doc?.formattedSize}</div>
                                  </div>
                                  <div className="flex-shrink-0 ms-2">
                                    <div className="d-flex gap-1">
                                      <Permission
                                        alternative={
                                          <Link
                                            className="btn btn-icon text-muted btn-sm fs-18"
                                            to={`#`}
                                          >
                                            <i className="ri-download-2-line "></i>
                                          </Link>
                                        }
                                        resource={"government-request"}
                                        action={"download"}
                                        controller="loa"
                                      >
                                        <Link
                                          className="btn btn-icon text-muted btn-sm fs-18"
                                          to={`${url}`}
                                          target={target}
                                        >
                                          <i className="ri-download-2-line"></i>
                                        </Link>
                                      </Permission>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        }
                      )) || (
                      <Col xxl={6} lg={6}>
                        <div className="border rounded border-dashed p-2">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <div className="avatar-sm">
                                <div className="avatar-title bg-light text-secondary rounded fs-24">
                                  <i className="ri-file-line text-primary"></i>
                                </div>
                              </div>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <h5 className="fs-13 mb-1">
                                <Permission
                                  alternative={
                                    <Link
                                      to="#"
                                      className="text-muted text-truncate d-block"
                                    >
                                      No Documents Uploaded
                                    </Link>
                                  }
                                  resource={"capacity-assessment"}
                                  action={"download"}
                                >
                                  <Link
                                    to={`#`}
                                    className="text-body text-truncate d-block"
                                  >
                                    No Documents Uploaded
                                  </Link>
                                </Permission>
                              </h5>
                              {/* <div>{"0 Files Found"}</div> */}
                            </div>
                            <div className="flex-shrink-0 ms-2">
                              <div className="d-flex gap-1"></div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </CardBody>
              <CardBody className="p-4">
                <div className="table-responsive"></div>
                <div className="border-top border-top-dashed mt-2">
                  <Table
                    className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                    style={{ width: "250px" }}
                  >
                    <tbody>
                      <tr className="border-top border-top-dashed fs-15">
                        <th scope="row">Total Value of Request</th>
                        <th className="text-end">
                          ${" "}
                          {(request?.totalValueOfRequest &&
                            request?.totalValueOfRequest?.toLocaleString()) ||
                            "Not Provided"}
                        </th>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="mt-4">
                  <div className="alert alert-info">
                    <p className="mb-0">
                      <span className="fw-semibold">NOTE:</span>
                      <span id="note">
                        {" "}
                        The data provided herein is shared by various agencies
                        and is intended solely for use within the United Nations
                        system. Unauthorized dissemination or distribution of
                        this data outside of the UN system is strictly
                        prohibited.
                      </span>
                    </p>
                  </div>
                </div>
                {/* <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                <Link
                  to="#"
                  onClick={printInvoice}
                  className="btn btn-success"
                >
                  <i className="ri-printer-line align-bottom me-1"></i>{" "}
                  Print
                </Link>
                <Link to="#" className="btn btn-primary">
                  <i className="ri-download-2-line align-bottom me-1"></i>{" "}
                  Download
                </Link>
              </div> */}
              </CardBody>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col xxl={3} className="mb-4">
        <Card className="h-100">
          <CardBody className="p-0">
            <div className="p-3">
              <h6 className="text-muted mb-0 text-uppercase fw-semibold">
                Activity
              </h6>
            </div>
            <SimpleBar style={{ maxHeight: "410px" }} className="p-3 pt-0">
              <div className="acitivity-timeline acitivity-main">
                <div className="acitivity-item d-flex">
                  <div className="flex-shrink-0 avatar-xs acitivity-avatar">
                    <div className="avatar-title bg-warning-subtle text-warning rounded-circle">
                      <i className="ri-time-line"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h6 className="mb-1 lh-base">Last Updated</h6>
                    <p className="text-muted mb-1">
                      {`By ${request?.createdby?.firstName || ""} ${
                        request?.createdby?.lastName || ""
                      } - ${request?.updatedby?.agency?.name || ""}`}
                    </p>
                    <small className="mb-0 text-muted">
                      {moment(new Date(request?.updatedAt)).format("DD MMM, Y")}
                    </small>
                  </div>
                </div>
                <div className="acitivity-item py-3 d-flex">
                  <div className="flex-shrink-0 avatar-xs acitivity-avatar">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle">
                      <i className="ri-calendar-line"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h6 className="mb-1 lh-base">Created</h6>
                    <p className="text-muted mb-1">
                      {`By ${request?.createdby?.firstName || ""} ${
                        request?.createdby?.lastName || ""
                      } - ${request?.createdby?.agency?.name || ""}`}
                    </p>
                    <p className="mb-0 text-muted">
                      <small>
                        {moment(new Date(request?.createdAt)).format(
                          "DD MMM, Y"
                        )}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </SimpleBar>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default LOAContent;
